export const BaseUrl: string =
  'https://asian-tourism-fair-management-server.m360ictapi.com';
// export const BaseUrl: string = 'http://10.10.220.45:5010';

export const imgUrl: string =
  'https://m360ict.s3.ap-south-1.amazonaws.com/asian_tourism_fair_storage';

export const CONTACT_INFO = {
  address:
    'House-97/1, 1st Floor (2B), Sukrabad, Sher-e-bangla Nagar, Dhaka-1207, Bangladesh.',
  email: 'asiantourismfair@gmail.com, info@asiantourismfair.com',
  phone: '+88 01819 224593, +88 01730 450099',
};

//======== Auth context helper ========//
export const SET_SIGNUP_DATA = 'SET_SIGNUP_DATA';
export const EXHIBITOR_USER_SUCCESS = 'AUTH_USER_SUCCESS';
export const EXHIBITOR_USER_FAILED = 'EXHIBITOR_USER_FAILED';
export const USER_PROFILE_UPDATE = 'USER_PROFILE_UPDATE';
export const VISITOR_PROFILE_IMAGE_UPDATE = 'VISITOR_PROFILE_IMAGE_UPDATE';
export const B2B_PROFILE_IMAGE_UPDATE = 'B2B_PROFILE_IMAGE_UPDATE';
//======== visitor Auth context helper ========//
export const AUTH_VISITOR_USER_SUCCESS = 'AUTH_VISITOR_USER_SUCCESS';
export const AUTH_VISITOR_USER_FAILED = 'AUTH_VISITOR_USER_FAILED';
export const B2B_USER_SUCCESS = 'B2B_USER_SUCCESS';
export const B2B_USER_FAILED = 'B2B_USER_FAILED';
